/**
 * WarningIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const WarningIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m23.184 20.507-10.28-18a1 1 0 0 0-1.74 0l-10.28 18a1 1 0 0 0 .87 1.5h20.56a1 1 0 0 0 .87-1.5m-11.15-1a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4m.8-3.8h-1.6s-.35-4.5-.4-6a1.2 1.2 0 1 1 2.4 0c-.05 1.5-.4 6-.4 6" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const WarningIcon = makeIcon('WarningIcon', WarningIconSvg)
